import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Container component for drawer content.
 * Provides structure and animations for the drawer panel.
 *
 * @example
 * ```html
 * <app-drawer>
 *   <app-drawer-header [title]="'My Drawer'" (close)="drawerRef.close()"></app-drawer-header>
 *
 *   <div class="drawer-body">
 *     <!-- Your content here -->
 *   </div>
 *
 *   <app-drawer-footer>
 *     <button mat-button (click)="cancel()">Cancel</button>
 *     <button mat-flat-button color="primary" (click)="save()">Save</button>
 *   </app-drawer-footer>
 * </app-drawer>
 * ```
 */
@Component({
  selector: 'app-drawer',
  standalone: true,
  template: `
    <div class="drawer-container">
      <ng-content select="app-drawer-header"></ng-content>
      <div class="drawer-content">
        <ng-content></ng-content>
      </div>
      <ng-content select="app-drawer-footer"></ng-content>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      .drawer-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background: white;
        box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);
        animation: slideInRight 0.3s ease-out;
      }

      .drawer-content {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
      }

      @keyframes slideInRight {
        from {
          transform: translateX(100%);
        }
        to {
          transform: translateX(0);
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerComponent {}
